export const stringifyYear = (year: string | number) => {
  return `key${year}`;
};

export const destringifyYear = (key: string) => {
  return key.slice(3);
};
